import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { BookmarkParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_RESERVOIR_MODELS_PAGE = graphql(`
  query StudyReservoirModelsPage($id: ID!) {
    studyGet(id: $id) {
      id
      reservoirModels {
        ...reservoirModelParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
      }
    }
  }
`);

export default function StudyReservoirModelsPage() {
  return (
    <ApolloProviderV4>
      <StudyReservoirModelsPageInner />
    </ApolloProviderV4>
  );
}

function StudyReservoirModelsPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_RESERVOIR_MODELS_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_RESERVOIR_MODELS_PAGE, variables: { id: studyId } },
  ]);

  const reservoirModels = data?.studyGet?.reservoirModels ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={reservoirModels}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.ReservoirModel}
      refetchQueries={refetchQueries}
    />
  );
}
